export default __webpack_public_path__ + "static/media/instrucciones-4.b85fbcba.jpg";